import React from 'react'
import { ChatFeed } from 'react-chat-ui'
import ChatSelector from './NewMessageContainer/ChatSelector'
import UnansweredMessageInfo from './UnansweredMessageInfo'
import ReggoraChatBubble from '../../common/widgets/ReggoraBubble'
import CommentTemplateDropdown from './CommentTemplateDropdown'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useTemplateTextHandler } from '@app/common/hooks'
import { getAudienceFilter } from '@app/pages/adminSettings/MessageTemplateManagement/MessageTemplates/helpers'

const MessagesTab = (props) => {
  const {
    messagesBubbles,
    messages,
    conversationParticipation,
    conversation,
    markReadMessages,
    is_amc_lender,
    isAppraiserMessages,
    subOrderId,
    conversationType,
    newMessageTitle,
    orderData,
  } = props
  const isTeamConversation = conversationType === 'team_conversation'
  const flags = useFlags() || {}

  const {
    textToInsert,
    selectedTemplate,
    setTextToInsert: handleTextToInsert,
    setSelectedTemplate,
  } = useTemplateTextHandler()

  const audienceFilter = getAudienceFilter({
    conversationType,
    isAmcLender: is_amc_lender,
    isAppraiserMessages,
  })

  const onNewMessageFocus = () => markReadMessages(conversation.id, conversationType)

  return (
    <div className="d-flex flex-column align-content-between chat-controls" name={conversationType}>
      <div className="chat-avatars">{messagesBubbles}</div>
      <ChatFeed
        messages={messages}
        chatBubble={ReggoraChatBubble}
        showSenderName={false}
      />
      {conversationParticipation && (
        ((is_amc_lender && isAppraiserMessages) || (isTeamConversation && flags?.useUpdatedMessageTemplatesUx)) ? (
          <>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', width: '100%' }}>
              <ChatSelector
                conversation_id={conversation.id}
                conversationType={conversationType}
                is_revision={false}
                modal={false}
                subOrderId={subOrderId}
                onFocus={onNewMessageFocus}
                newMessageTitle={newMessageTitle}
                orderData={orderData}
                is_amc_lender={is_amc_lender}
                textToInsert={textToInsert}
                setTextToInsert={handleTextToInsert}
                selectedTemplate={selectedTemplate}
                setSelectedTemplate={setSelectedTemplate}
                resetTextToInsert={() => handleTextToInsert('')}
                allowMessageParticipation={true}
                shouldGetMessages={true}
                primaryConversationType={conversationType}
                primaryConversation={conversation}
                onHide={props.onHide}
                refreshOrder={props.refreshOrder}
                isUnifiedConversation={conversationType === 'unified_conversation'}
                isTemplateSuggestionEnabled={false}
                audienceFilter={audienceFilter}
              />
            </div>
            {!flags?.useUpdatedMessageTemplatesUx && isAppraiserMessages && <CommentTemplateDropdown
              name={'appraiser-messages-templates-list'}
              onHide={props.onHide}
              refreshOrder={props.refreshOrder}
              setTextToInsert={handleTextToInsert}
              setSelectedTemplate={setSelectedTemplate}
            />}
          </>
        ) : <ChatSelector
          conversation_id={conversation.id}
          conversationType={conversationType}
          is_revision={false}
          modal={false}
          subOrderId={subOrderId}
          onFocus={onNewMessageFocus}
          newMessageTitle={newMessageTitle}
          textToInsert={textToInsert}
          setTextToInsert={handleTextToInsert}
          orderData={orderData}
          is_amc_lender={is_amc_lender}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          resetTextToInsert={() => handleTextToInsert('')}
          allowMessageParticipation={true}
          shouldGetMessages={true}
          primaryConversationType={conversationType}
          primaryConversation={conversation}
          onHide={props.onHide}
          refreshOrder={props.refreshOrder}
          isUnifiedConversation={conversationType === 'unified_conversation'}
          audienceFilter={audienceFilter}
        />
      )}
      {isAppraiserMessages && (
        <UnansweredMessageInfo
          primaryConversation={conversation || {}}
          is_amc_lender={is_amc_lender}
          shouldGetMessages={true}
        />
      )}
    </div>
  )
}

export default MessagesTab
